export function getPatternErrorMessage(pattern: string): string {
  // FILE EXTENSIONS (jpg|png|pdf)
  const filesExtMatch = pattern.match(/\\?\.\(([^)]+)\)/);
  if (filesExtMatch) {
    const exts = filesExtMatch[1].split('|').map((ext) => `.${ext}`);
    const extsStr = exts.join(', ');

    return `Please enter a valid file name ending with: ${extsStr}.`;
  }

  // SINGLE FILE EXTENSION
  const singleExtMatch = pattern.match(/\\\.([a-z0-9]+)/i);
  if (singleExtMatch) {
    const ext = `.${singleExtMatch[1]}`;
    return `Please enter a valid file name ending with: ${ext}.`;
  }

  // NUMBERS ONLY
  if (
    (pattern.includes('[0-9]') || pattern.includes('\\d')) &&
    !/[a-zA-Z]/.test(pattern)
  ) {
    return `Only numbers are allowed.`;
  }

  // LETTERS ONLY
  if (
    pattern.includes('[a-zA-Z]') &&
    !pattern.includes('[0-9]') &&
    !pattern.includes('\\d')
  ) {
    return `Only letters are allowed.`;
  }

  // ALPHANUMERIC
  if (
    pattern.includes('[a-zA-Z0-9]') ||
    (pattern.includes('[a-zA-Z]') &&
      (pattern.includes('[0-9]') || pattern.includes('\\d')))
  ) {
    return `Only letters and numbers are allowed.`;
  }

  // GENERIC fallback
  return `Value does not match the required pattern: ${pattern}`;
}
